import { useEffect } from 'react';

export const useHighlightFocus = () => {
  const setOnFocus = (e: KeyboardEvent) => {
    if (document.activeElement) {
      const code = e.code;
      if (code === 'Tab') {
        clearFocus();

        document.activeElement.className = `${document.activeElement.className} tabbed`;
        const closest = document.activeElement.closest('.highlightable');
        if (closest) {
          closest.className = `${closest.className} tabbed`;
        }
      }
    }
  };

  const clearFocus = () => {
    const list = document.getElementsByClassName('tabbed');
    for (let i = 0; i < list.length; i++) {
      const element = list[i];
      element.className = element.className.replaceAll('tabbed', '').trim();
    }
  };

  useEffect(() => {
    window.addEventListener('keyup', setOnFocus);
    window.addEventListener('click', clearFocus);

    return () => {
      window.removeEventListener('keyup', setOnFocus);
      window.removeEventListener('click', clearFocus);
    };
  });
};
